import script from "./SingleSuggestion.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleSuggestion.vue?vue&type=script&setup=true&lang=js"

import "./SingleSuggestion.vue?vue&type=style&index=0&id=b59803da&lang=css"

const __exports__ = script;

export default __exports__